export default "__VITE_ASSET__Vh9QzaKx__"